import { render } from "./ContentInfoModal.vue?vue&type=template&id=770d777a&scoped=true"
import script from "./ContentInfoModal.vue?vue&type=script&lang=js"
export * from "./ContentInfoModal.vue?vue&type=script&lang=js"

import "./ContentInfoModal.vue?vue&type=style&index=0&id=770d777a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-770d777a"]])

export default __exports__